document.addEventListener("DOMContentLoaded", function () {

  const raven = document.getElementById("raven-shadow");
  const triggers = document.querySelectorAll("a, .card, .product-card");

  triggers.forEach(item => {
    item.addEventListener("mouseenter", () => {

      raven.classList.remove("raven-fly");

      void raven.offsetWidth;

      raven.classList.add("raven-fly");

    });
  });

});